import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Home } from './pages/Home';
import { WeightLoss } from './pages/WeightLoss';
import { MensHealth } from './pages/MensHealth';
import { Investors } from './pages/Investors';
import { PhysicianProfile } from './pages/PhysicianProfile';
import { PhysicianProfileHodor } from './pages/PhysicianProfileHodor';
import { PhysicianProfileKhan } from './pages/PhysicianProfileKhan';
import { PhysicianProfileWoodhouse } from './pages/PhysicianProfileWoodhouse';
import { PhysicianProfileAnyaoku } from './pages/PhysicianProfileAnyaoku';
import { TelehealthConsent } from './pages/TelehealthConsent';
import { WeightLossConsent } from './pages/WeightLossConsent';
import { ScrollToTop } from './components/ScrollToTop';
export function AppRouter() {
  return <BrowserRouter data-id="element-6">
      <ScrollToTop data-id="element-7" />
      <Routes data-id="element-8">
        <Route path="/" element={<App data-id="element-10" />} data-id="element-9">
          <Route index element={<Home data-id="element-12" />} data-id="element-11" />
          <Route path="weight-loss" element={<WeightLoss data-id="element-14" />} data-id="element-13" />
          <Route path="mens-health" element={<MensHealth data-id="element-16" />} data-id="element-15" />
          <Route path="investors" element={<Investors data-id="element-18" />} data-id="element-17" />
          <Route path="network-physician/Manharkumar-Patel" element={<PhysicianProfile data-id="element-20" />} data-id="element-19" />
          <Route path="network-physician/Hodor-Jonathan" element={<PhysicianProfileHodor data-id="element-22" />} data-id="element-21" />
          <Route path="network-physician/Aliya-Khan" element={<PhysicianProfileKhan data-id="element-24" />} data-id="element-23" />
          <Route path="network-physician/Cristina-Woodhouse" element={<PhysicianProfileWoodhouse data-id="element-26" />} data-id="element-25" />
          <Route path="network-physician/Jacinta-Anyaoku" element={<PhysicianProfileAnyaoku data-id="element-28" />} data-id="element-27" />
          <Route path="telehealth-consent" element={<TelehealthConsent data-id="element-30" />} data-id="element-29" />
          <Route path="weight-loss-consent" element={<WeightLossConsent data-id="element-32" />} data-id="element-31" />
        </Route>
      </Routes>
    </BrowserRouter>;
}